import _defineProperty from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/mitch/Code/Afterpay/Careers/App/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { MOST_NEGATIVE_SINGLE_FLOAT, MOST_POSITIVE_SINGLE_FLOAT } from '../constants';
import { isActiveAudioNode } from '../helpers/is-active-audio-node';
import { setInternalStateToActive } from '../helpers/set-internal-state-to-active';
import { setInternalStateToPassive } from '../helpers/set-internal-state-to-passive';
var DEFAULT_OPTIONS = {
  channelCount: 2,
  channelCountMode: 'max',
  channelInterpretation: 'speakers',
  offset: 1
};
export var createConstantSourceNodeConstructor = function createConstantSourceNodeConstructor(audioNodeConstructor, createAudioParam, createConstantSourceNodeRendererFactory, createNativeConstantSourceNode, getNativeContext, isNativeOfflineAudioContext, wrapEventListener) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(ConstantSourceNode, _audioNodeConstructor);

    var _super = _createSuper(ConstantSourceNode);

    function ConstantSourceNode(context, options) {
      var _this;

      _classCallCheck(this, ConstantSourceNode);

      var nativeContext = getNativeContext(context);

      var mergedOptions = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

      var nativeConstantSourceNode = createNativeConstantSourceNode(nativeContext, mergedOptions);
      var isOffline = isNativeOfflineAudioContext(nativeContext);
      var constantSourceNodeRenderer = isOffline ? createConstantSourceNodeRendererFactory() : null;
      _this = _super.call(this, context, false, nativeConstantSourceNode, constantSourceNodeRenderer);
      _this._constantSourceNodeRenderer = constantSourceNodeRenderer;
      _this._nativeConstantSourceNode = nativeConstantSourceNode;
      /*
       * Bug #62 & #74: Safari does not support ConstantSourceNodes and does not export the correct values for maxValue and minValue
       * for GainNodes.
       */

      _this._offset = createAudioParam(_assertThisInitialized(_this), isOffline, nativeConstantSourceNode.offset, MOST_POSITIVE_SINGLE_FLOAT, MOST_NEGATIVE_SINGLE_FLOAT);
      _this._onended = null;
      return _this;
    }

    _createClass(ConstantSourceNode, [{
      key: "start",
      value: function start() {
        var _this2 = this;

        var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        this._nativeConstantSourceNode.start(when);

        if (this._constantSourceNodeRenderer !== null) {
          this._constantSourceNodeRenderer.start = when;
        }

        if (this.context.state !== 'closed') {
          setInternalStateToActive(this);

          var resetInternalStateToPassive = function resetInternalStateToPassive() {
            _this2._nativeConstantSourceNode.removeEventListener('ended', resetInternalStateToPassive); // @todo Determine a meaningful delay instead of just using one second.


            setTimeout(function () {
              if (isActiveAudioNode(_this2)) {
                setInternalStateToPassive(_this2);
              }
            }, 1000);
          };

          this._nativeConstantSourceNode.addEventListener('ended', resetInternalStateToPassive);
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        this._nativeConstantSourceNode.stop(when);

        if (this._constantSourceNodeRenderer !== null) {
          this._constantSourceNodeRenderer.stop = when;
        }
      }
    }, {
      key: "offset",
      get: function get() {
        return this._offset;
      }
    }, {
      key: "onended",
      get: function get() {
        return this._onended;
      },
      set: function set(value) {
        var wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
        this._nativeConstantSourceNode.onended = wrappedListener;
        var nativeOnEnded = this._nativeConstantSourceNode.onended;
        this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
      }
    }]);

    return ConstantSourceNode;
  }(audioNodeConstructor);
};